<template>
  <v-dialog
    v-model="dialog"
    width="unset"
    class="preview-modal">
    <v-card class="preview-image-card">
      <div class="preview-image-box">
        <img
          :src="$convertImgix(imgSrc)"
          class="preview-image"
          alt="preview-image">
      </div>
      <v-btn
        class="preview-image-close"
        elevation="5"
        icon
        @click="closeDialog()">
        <v-icon color="#a4a4a4">
          mdi-close
        </v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    imgSrc: {
      type: String,
      default: null
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  methods: {
    closeDialog () {
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-image-card {
  position: relative;
  img.preview-image {
    height: 80vh;
    width: auto;
    max-width: auto !important;
  }
  .preview-image-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: white;
  }
}

.preview-modal {
  z-index: 10000;
}
</style>
